import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { FeaturedAdsListPayloadDto } from '../../dto';
import { FeaturedAdDto } from '../../dto';

type GetFeaturedAdsListOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function getFeaturedAdsList(
  baseUrl: string,
  payload: FeaturedAdsListPayloadDto,
  snowplowData = '',
  options?: GetFeaturedAdsListOptions,
): Promise<IHttpResponse<FeaturedAdDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<FeaturedAdsListPayloadDto> = {
    url: `${baseUrl}/api/searchads`,
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'application/json',
      'snowplow-data': snowplowData,
      ...headers,
    },
    schemas: {
      request: FeaturedAdsListPayloadDto,
      response: FeaturedAdDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
